import Vue from 'vue';
import Router from 'vue-router';
const Home = () => import('@/components/Home');
const Signup = () => import('@/components/User/Signup');
const DeviceCreation = () => import('@/components/Device/new/DeviceCreationMap');
const DeviceDetail = () => import('@/components/Device/Item/DeviceDetail');
const Signin = () => import('@/components/User/Signin');
const Dashboard = () => import('@/components/Dashboard/DashboardMainScreen');
const Equipments = () => import('@/components/Device/Equipments');
import AuthGuard from './auth-guard';
const UserInfo = () => import('@/components/User/UserInfo');
const NewOrganization = () => import('@/components/User/NewOrganization');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      beforeEnter: AuthGuard
    },
    {
      path: '/newOrganization',
      name: 'NewOrganization',
      component: NewOrganization,
      beforeEnter: AuthGuard
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signup2',
      name: 'Signup2',
      component: Signup,
      beforeEnter: AuthGuard
    },
    {
      path: '/deviceCreation',
      name: 'Device',
      component: DeviceCreation,
      beforeEnter: AuthGuard
    },
    {
      path: '/deviceDetail/:id',
      name: 'DeviceDetail',
      component: DeviceDetail,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin,
      beforeEnter: AuthGuard
    },
    {
      path: '/userInfo',
      name: 'UserInfo',
      component: UserInfo,
      beforeEnter: AuthGuard
    },
    {
      path: '/equipments',
      name: 'Equipments',
      component: Equipments,
      beforeEnter: AuthGuard
    }
  ],
  mode: 'history'
});



// WEBPACK FOOTER //
// ./src/router/index.js